package org.dronda.app.web.ui.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

/**
 * A stateless labelled input whose value is owned by the caller (typically a ViewModel).
 */
@Composable
fun TextField(
    value: String,
    onValueChange: (String) -> Unit,
    label: String,
    labelId: String,
    inputType: InputType<String> = InputType.Text,
    error: String? = null,
    disabled: Boolean = false,
    onEnter: (() -> Unit)? = null,
    modifier: Modifier = Modifier,
) {
    Div(Modifier.display(DisplayStyle.Grid).gap(0.5.cssRem).then(modifier).toAttrs()) {
        Label(labelId) { Text(label) }
        Input(inputType) {
            id(labelId)
            style {
                padding(0.5.cssRem)
                borderRadius(2.px)
                property("width", "100%")
                property("box-sizing", "border-box")
                border {
                    style = LineStyle.Solid
                    width = 1.px
                    color = rgb(176, 176, 176)
                }
            }
            value(value)
            onInput { onValueChange(it.value) }
            if (onEnter != null) {
                onKeyDown { if (it.key == "Enter") onEnter() }
            }
            if (disabled) disabled()
        }
        if (error != null) {
            P({ style { color(AppColors.danger) } }) { Text(error) }
        }
    }
}
